import { useCallback, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { UserPlus } from "lucide-react";
import { adminApi } from "../../../api/resources";
import { PageHeader } from "../../../components/ComingSoon";
import { Tabs } from "../../../components/Overlay";
import { Button } from "../../../components/ui";
import { EmployeesTab } from "./EmployeesTab";
import { InvitationsTab } from "./InvitationsTab";
import { InviteModal, PreviewLink } from "./InviteModal";
import { ReviewTab } from "./ReviewTab";
import { PhoneConflictsTab } from "./PhoneConflictsTab";
import { smsApi } from "../../../api/resources";

export default function AdminEmployees() {
  const [params, setParams] = useSearchParams();
  const tab = params.get("tab") ?? "employees";
  const status = params.get("status") ?? "";
  const [inviteOpen, setInviteOpen] = useState(false);
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);
  const [reloadKey, setReloadKey] = useState(0);
  const [reviewCount, setReviewCount] = useState<number | undefined>(undefined);
  const [conflictCount, setConflictCount] = useState<number | undefined>(undefined);

  const refreshCount = useCallback(() => {
    adminApi.invitations("NEEDS_REVIEW").then((r) => setReviewCount(r.length)).catch(() => setReviewCount(undefined));
    smsApi.conflicts("OPEN").then((r) => setConflictCount(r.length)).catch(() => setConflictCount(undefined));
  }, []);
  useEffect(refreshCount, [refreshCount, reloadKey]);

  const go = (t: string, s = "") => setParams(s ? { tab: t, status: s } : { tab: t });
  const changed = (url?: string | null) => {
    if (url) setPreviewUrl(url);
    setReloadKey((k) => k + 1);
  };

  return (
    <section data-testid="admin-employees-page" className="animate-rise">
      <PageHeader title="Employees">
        <div className="flex items-center gap-4">
          <button type="button" onClick={() => go("review")} data-testid="needs-review-count" className="text-sm text-zinc-400 hover:text-white">
            Needs review: <span className={reviewCount ? "font-semibold text-signal" : "text-white"}>{reviewCount ?? "–"}</span>
          </button>
          <Button onClick={() => setInviteOpen(true)} data-testid="open-invite-modal-button"><UserPlus className="h-4 w-4" /> Invite</Button>
        </div>
      </PageHeader>
      <PreviewLink url={previewUrl} onDismiss={() => setPreviewUrl(null)} />
      <Tabs active={tab} onChange={(t) => go(t)} tabs={[
        { key: "employees", label: "Employees" },
        { key: "invitations", label: "Invitations" },
        { key: "review", label: "Needs review", count: reviewCount },
        { key: "conflicts", label: "Phone conflicts", count: conflictCount },
      ]} />
      {tab === "employees" && <EmployeesTab status={status} onStatus={(s) => go("employees", s)} />}
      {tab === "invitations" && <InvitationsTab status={status} onStatus={(s) => go("invitations", s)} reloadKey={reloadKey} onChanged={changed} />}
      {tab === "review" && <ReviewTab reloadKey={reloadKey} onChanged={() => changed()} />}
      {tab === "conflicts" && <PhoneConflictsTab reloadKey={reloadKey} onChanged={() => changed()} />}
      <InviteModal open={inviteOpen} onClose={() => setInviteOpen(false)} onCreated={(url) => { changed(url); go("invitations"); }} />
    </section>
  );
}
